/** Enum para os status da revisão das Análises de Mercado */
export enum ClienteAnaliseMercadoRevisaoStatus {
    SEM_REVISAO = 0,
    ABERTA = 1,
    APROVADA = 2
}

/** Valor de um status de revisão das Análises de Mercado */
export interface ClienteAnaliseMercadoRevisaoStatusValue {
    id: ClienteAnaliseMercadoRevisaoStatus,
    nome: string;
    backgroundColor: string;
    color: string;
}

/** Sem Revisão */
export const CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_SEM_REVISAO: ClienteAnaliseMercadoRevisaoStatusValue = {
    id: ClienteAnaliseMercadoRevisaoStatus.SEM_REVISAO,
    nome: 'Sem Revisão',
    backgroundColor: '#cdcdcd',
    color: '#565656'
};

/** Revisão Aberta */
export const CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_ABERTA: ClienteAnaliseMercadoRevisaoStatusValue = {
    id: ClienteAnaliseMercadoRevisaoStatus.ABERTA,
    nome: 'Aberta',
    backgroundColor: '#d0e3f7',
    color: '#237dd8'
};

/** Revisão Aprovada */
export const CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_APROVADA: ClienteAnaliseMercadoRevisaoStatusValue = {
    id: ClienteAnaliseMercadoRevisaoStatus.APROVADA,
    nome: 'Aprovada',
    backgroundColor: '#b2f1cb',
    color: '#20b75d'
};

/** Status das Revisões das Análises de Mercado */
export const CLIENTE_ANALISE_MERCADO_REVISAO_STATUSES: ClienteAnaliseMercadoRevisaoStatusValue[] = [
    CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_SEM_REVISAO,
    CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_ABERTA,
    CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_APROVADA
];

/** Verifica se o status da revisão é Sem Revisão */
export function isClienteAnaliseMercadoRevisaoStatusSemRevisao(status: number): boolean {
    return status === CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_SEM_REVISAO.id;
}

/** Verifica se o status da revisão é Aberta */
export function isClienteAnaliseMercadoRevisaoStatusAberta(status: number): boolean {
    return status === CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_ABERTA.id;
}

/** Verifica se o status da revisão é Aprovada */
export function isClienteAnaliseMercadoRevisaoStatusAprovada(status: number): boolean {
    return status === CLIENTE_ANALISE_MERCADO_REVISAO_STATUS_APROVADA.id;
}

/** Obtém o status da revisão pelo id */
export function getClienteAnaliseMercadoRevisaoStatus(status: number): ClienteAnaliseMercadoRevisaoStatusValue {
    return CLIENTE_ANALISE_MERCADO_REVISAO_STATUSES.find(statusFiler => statusFiler.id === status);
}
